var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { useEffect, useState } from 'react';
import { isURL } from 'validator';
import { createSelector } from '@reduxjs/toolkit';
import { useAppSelector } from '../../store';
const themeSelector = createSelector(_react_refresh_temp_1 = (state) => state.roomSettings, (roomSettings) => roomSettings.theme);
$RefreshReg$(_react_refresh_temp_1, "themeSelector$createSelector");
const useLogo = (logo_type = 'main') => {
    var _a;
    _react_refresh_temp_2();
    const assetPath = (_a = window.STATIC_ASSETS_PATH) !== null && _a !== void 0 ? _a : './assets';
    const theme = useAppSelector(themeSelector);
    const [logo, setLogo] = useState(`${assetPath}/imgs/logo.svg`);
    useEffect(() => {
        const logo = window.CUSTOM_LOGO;
        const validUrlOptions = {
            protocols: ['http', 'https'],
            require_protocol: true,
        };
        if (typeof logo === 'undefined') {
            return;
        }
        if (typeof logo === 'string' && isURL(logo, validUrlOptions)) {
            setLogo(logo);
            return;
        }
        if (typeof logo !== 'object') {
            return;
        }
        if (logo_type === 'waiting-room') {
            if (theme === 'dark' &&
                logo.waiting_room_logo_dark &&
                isURL(logo.waiting_room_logo_dark, validUrlOptions)) {
                setLogo(logo.waiting_room_logo_dark);
            }
            else if (logo.waiting_room_logo_light &&
                isURL(logo.waiting_room_logo_light, validUrlOptions)) {
                setLogo(logo.waiting_room_logo_light);
            }
        }
        else {
            if (theme === 'dark' &&
                logo.main_logo_dark &&
                isURL(logo.main_logo_dark, validUrlOptions)) {
                setLogo(logo.main_logo_dark);
            }
            else if (logo.main_logo_light &&
                isURL(logo.main_logo_light, validUrlOptions)) {
                setLogo(logo.main_logo_light);
            }
        }
    }, [theme, logo_type]);
    return logo;
};
_react_refresh_temp_2(useLogo, "Pb/N7+oiaudYzgkCZjsqkAV+6GM=", false, () => [useAppSelector]);
export default useLogo;
